import React from 'react';

function Main(props) {
    return (
        <div>SERVICE PAGE</div>
    );
  }

export default Main